import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

import { svgIconClassName } from '@archipro-design/icons';
export const Container: StyleRule = () => ({
    width: '100%',

    [`& > div`]: {
        marginBottom: `-1px`,
    },
    overflow: 'hidden',
});

export const Nav: StyleRule = () => ({
    gap: pxToRem(46),
});

export const NavItem: StyleRule = ({ theme }) => ({
    display: 'flex',
    alignItems: `center`,
    justifyContent: `center`,
    width: 'fit-content',
    color: theme.siteVariables.colorScheme.default?.foregroundDisabled,
    fontSize: theme.siteVariables.fontSizes['label03-alt'],
    lineHeight: theme.siteVariables.lineHeightSmall,
    fontWeight: theme.siteVariables.fontWeightLight,
    whiteSpace: 'nowrap',
    padding: pxArrayToRem([0, 16]),

    [`&:hover`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
    },

    '&.active': {
        color: theme.siteVariables.colorScheme.default?.foreground,
        fontWeight: theme.siteVariables.fontWeightRegular,
        background: 'transparent',
    },
});

export const NavContainer: StyleRule = () => ({
    position: 'relative',
    display: 'inline-block',

    [`&:hover`]: {
        [`& .articles-Nav__SubNavList`]: {
            display: 'flex',
            flexDirection: 'column',
        },
    },
});
export const SubNavList: StyleRule = ({ theme }) => ({
    background: theme.siteVariables.colors.white['FFF'],
    position: 'fixed',
    margin: pxArrayToRem([0, 16]),
    padding: 0,
    width: pxToRem(300),
    boxShadow: theme.siteVariables.shadowLevel3,
    display: 'none',
    height: 'fit-content',
    zIndex: theme.siteVariables.zIndexes.menuItem,
});

export const SubNavListItem: StyleRule = ({ theme }) => ({
    display: 'flex',
    paddingRight: pxToRem(12),
    alignItems: 'center',
    width: '100%',
    height: pxToRem(40),
    gap: pxToRem(4),
    justifyContent: 'space-between',
    userSelect: 'none',
    zIndex: theme.siteVariables.zIndexes.foreground,
    [`&:hover`]: {
        background: theme.siteVariables.colors.transparency.black['6%'],
    },
});
export const SubNavLink: StyleRule = ({ theme }) => ({
    padding: pxToRem(12),
    color: theme.siteVariables.colors.charcoal['250'],
    textTransform: 'uppercase',
    width: '100%',

    '&.active': {
        fontWeight: theme.siteVariables.textStyles.Display.Roman55.fontWeight,
    },

    [`&.active+.${svgIconClassName}`]: {
        display: 'flex',
    },
});

export const SubNavLinkActiveIcon: StyleRule = () => ({
    display: 'none',
});
